import React from 'react';
import { Typography } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import { TabPanel } from '../../sharedComponents/TapPanel';

const TapPanelChips = props => {
  const { scheme, value, classes, onSelectForm, fields } = props;
  return (
    <div style={{ display: 'flex' }}>
      {scheme?.grupos.map((group, index) => (
        <TabPanel value={value} index={index} key={index}>
          {scheme.grupos[value]?.tablas.map((table, i) => (
            <div key={`${table.tabla_display}${i}`} className={classes.chips}>
              <Chip
                label={
                  <Typography component="span" variant="body2">
                    {table.tabla_display}{' '}
                  </Typography>
                }
                clickable
                style={{
                  backgroundColor: fields?.tabla_display === table.tabla_display ? '#FFA500' : '#1b1b1b',
                }}
                color="primary"
                onClick={() => onSelectForm(table, group)}
              />
            </div>
          ))}
        </TabPanel>
      ))}
    </div>
  )
};

export default TapPanelChips;
